"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var styles_module_scss_1 = __importDefault(require("./styles.module.scss"));
var next_intl_1 = require("next-intl");
var SecondSlide = function (_a) {
    var defaultCurrency = _a.defaultCurrency, secondDepPercents = _a.secondDepPercents, secondDepMaxBonus = _a.secondDepMaxBonus, thirdDepPercents = _a.thirdDepPercents, thirdDepMaxBonus = _a.thirdDepMaxBonus, thirdDepFreespins = _a.thirdDepFreespins, fourthDepPercents = _a.fourthDepPercents, fourthDepMaxBonus = _a.fourthDepMaxBonus, fourthDepFreespins = _a.fourthDepFreespins;
    var t = (0, next_intl_1.useTranslations)('translation');
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement("div", { className: styles_module_scss_1.default.container },
            react_1.default.createElement("div", { style: { position: 'relative', width: '100%' } },
                react_1.default.createElement("div", { className: styles_module_scss_1.default.cardContentWrapper },
                    react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.cardContent, " ").concat(styles_module_scss_1.default.blue) },
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.bonus },
                            secondDepPercents,
                            "%"),
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.text }, t('onDeposit2')),
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.upTo }, t('upToOnlyCash', {
                            maxBonus: "".concat(secondDepMaxBonus, " ").concat(defaultCurrency),
                        }))),
                    react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.cardContent, " ").concat(styles_module_scss_1.default.green) },
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.bonus },
                            thirdDepPercents,
                            "%"),
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.text }, t('onDeposit3')),
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.upTo, dangerouslySetInnerHTML: {
                                __html: t('upToFresspins', {
                                    maxBonus: "".concat(thirdDepMaxBonus),
                                    freespins: thirdDepFreespins,
                                }),
                            } })),
                    react_1.default.createElement("div", { className: "".concat(styles_module_scss_1.default.cardContent, " ").concat(styles_module_scss_1.default.light) },
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.bonus },
                            fourthDepPercents,
                            "%"),
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.text }, t('onDeposit4')),
                        react_1.default.createElement("div", { className: styles_module_scss_1.default.upTo, dangerouslySetInnerHTML: {
                                __html: t('upToFresspins', {
                                    maxBonus: "".concat(fourthDepMaxBonus, " ").concat(defaultCurrency),
                                    freespins: fourthDepFreespins,
                                }),
                            } })))))));
};
exports.default = SecondSlide;
